<div class="weekly-timeline">
  <div class="timeline-heading">
    <h3>{{region | regionLabelMap }} - Changelog</h3>
    <div>
      <button class="btn btn-primary advisory" [ngClass]="{'not-selected' : !isAdvisory }"
        (click)="isAdvisory = !isAdvisory">Advisory</button>
      <button class="btn btn-primary developer" [ngClass]="{'not-selected' : !isDeveloper }"
        (click)="isDeveloper = !isDeveloper">Developer</button>
      <button class="btn btn-primary inventory" [ngClass]="{'not-selected' : !isInventory }"
        (click)="isInventory = !isInventory">Inventory</button>
      <button class="btn btn-primary ivt" [ngClass]="{'not-selected' : !isIvt }" (click)="isIvt = !isIvt">IVT</button>
      <button class="btn btn-primary risk-overview" [ngClass]="{'not-selected' : !isRiskOverview }"
        (click)="isRiskOverview = !isRiskOverview">Risk Overview</button>
      <button class="btn btn-primary seller" [ngClass]="{'not-selected' : !isSeller }"
        (click)="isSeller = !isSeller">Authorized Seller</button>
      <button class="btn btn-primary traffic" [ngClass]="{'not-selected' : !isTraffic }"
        (click)="isTraffic = !isTraffic">Traffic</button>
    </div>
  </div>
  <div class="timeline-cont">
    <ng-container *ngIf="changeLogMonths">
      <ng-container *ngFor="let changelogMonth of changeLogMonths">
        <h3 class="month">{{changelogMonth.label}}</h3>
        <ul class="timeline">
          <ng-container *ngFor="let changelog of changelogMonth.weeks">
            <li>
              <div class="date-info">
                <div class="day">{{changelog.day}}</div>
                <div class="date">{{changelog.num}}</div>
              </div>

              <!-- Risk Overview -- Overall Risk Change -->
              <ng-container *ngIf="changelog.doc.pixalateRisk && isRiskOverview">
                <div class="timeline-change-item">
                  <span class="detail-section risk-overview">Risk Overview</span> Pixalate Risk level changed to&nbsp;
                  <risk-heat-meter [risk]='changelog.doc["pixalateRisk"]["latestVal"]'></risk-heat-meter>
                </div>
              </ng-container>

              <!-- Risk Overview -- IVT Change (%) -->
              <ng-container *ngIf="changelog.doc.ivt && isRiskOverview">
                <div class="timeline-change-item">
                  <span class="detail-section risk-overview">Risk Overview</span> IVT
                  {{changelog.doc['ivt']['latestVal']
                  | abperc:'1.2-2'}}
                  <span class="change-value {{changelog.doc['ivt']['change'] > 0 ? 'decrease': ''}}">
                    (
                    <ng-container *ngIf="changelog.doc['ivt']['change']>0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#248D48"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="translate(-37 -4)" />
                      </svg>
                    </ng-container>
                    <ng-container *ngIf="changelog.doc['ivt']['change']<0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#D12727"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="matrix(1 0 0 -1 -37 10)" />
                      </svg>
                    </ng-container>
                    {{changelog.doc['ivt']['change'] | abperc:'1.2-2'}})
                  </span>
                </div>
              </ng-container>

              <!-- Risk Overview -- Viewability Change (%) -->
              <ng-container *ngIf="changelog.doc.viewability && isRiskOverview">
                <div class="timeline-change-item">
                  <span class="detail-section risk-overview">Risk Overview</span> Viewability
                  {{changelog.doc['viewability']['latestVal'] | abperc:'1.2-2'}}
                  <span class="change-value {{changelog.doc['viewability']['change'] < 0 ? 'decrease': ''}}">
                    (
                    <ng-container *ngIf="changelog.doc['viewability']['change']>0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#248D48"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="translate(-37 -4)" />
                      </svg>
                    </ng-container>
                    <ng-container *ngIf="changelog.doc['viewability']['change']<0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#D12727"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="matrix(1 0 0 -1 -37 10)" />
                      </svg>
                    </ng-container>
                    {{changelog.doc['viewability']['change'] | abperc:'1.2-2'}}
                    )
                  </span>
                </div>
              </ng-container>

              <!-- Advisory -- App-ads.txt -->
              <ng-container *ngIf="changelog.doc.hasAdsTxt && isAdvisory">
                <div class="timeline-change-item">
                  <span class="detail-section advisory">Advisory</span> App-ads.txt
                  {{changelog.doc['hasAdsTxt']['latestVal'] === 'true' ? 'detected' : 'not detected'}}
                </div>
              </ng-container>

              <!-- Advisory -- Blocklisted -->
              <ng-container *ngIf="changelog.doc.blocklisted && isAdvisory">
                <div class="timeline-change-item">
                  <span class="detail-section advisory">Advisory</span> Blocklist
                  {{changelog.doc['blocklisted']['latestVal'] === 'true' ? 'added' : 'removed'}}
                </div>
              </ng-container>

              <!-- Advisory -- COPPA Violation Risk -->
              <ng-container *ngIf="changelog.doc.coppaRisk && isAdvisory">
                <div class="timeline-change-item">
                  <span class="detail-section advisory">Advisory</span> COPPA Violation Risk level changed to&nbsp;
                  <risk-heat-meter [risk]='changelog.doc["coppaRisk"]["latestVal"]'></risk-heat-meter>
                </div>
              </ng-container>

              <!-- Advisory -- App Permission Risk -->
              <ng-container *ngIf="changelog.doc.ivtPermissionRisk && isAdvisory">
                <div class="timeline-change-item">
                  <span class="detail-section advisory">Advisory</span> App Permission Risk level changed to&nbsp;
                  <risk-heat-meter [risk]='changelog.doc["ivtPermissionRisk"]["latestVal"]'></risk-heat-meter>
                </div>
              </ng-container>

              <!-- Brand Safety -- Brand Safety -->
              <ng-container *ngIf="changelog.doc.contentBrandSafetyRisk && isBrandSafety">
                <div class="timeline-change-item">
                  <span class="detail-section traffic">Brand Safety</span> Brand Safety Risk level changed to&nbsp;
                  <risk-heat-meter [risk]='changelog.doc["contentBrandSafetyRisk"]["latestVal"]'></risk-heat-meter>
                </div>
              </ng-container>

              <!-- IVT -- GIVT -->
              <ng-container *ngIf="changelog.doc.givt && isIvt">
                <div class="timeline-change-item">
                  <span class="detail-section ivt">IVT</span> GIVT {{changelog.doc['givt']['latestVal'] |
                  abperc:'1.2-2'}}
                  <span class="change-value {{changelog.doc['givt']['change'] > 0 ? 'decrease': ''}}">
                    (
                    <ng-container *ngIf="changelog.doc['givt']['change']>0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#248D48"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="translate(-37 -4)" />
                      </svg>
                    </ng-container>
                    <ng-container *ngIf="changelog.doc['givt']['change']<0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#D12727"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="matrix(1 0 0 -1 -37 10)" />
                      </svg>
                    </ng-container>
                    {{changelog.doc['givt']['change'] | abperc:'1.2-2'}})
                  </span>
                </div>
              </ng-container>

              <!-- IVT -- SIVT -->
              <ng-container *ngIf="changelog.doc.sivt && isIvt">
                <div class="timeline-change-item">
                  <span class="detail-section ivt">IVT</span> SIVT {{changelog.doc['sivt']['latestVal'] |
                  abperc:'1.2-2'}}
                  <span class="change-value {{changelog.doc['sivt']['change'] > 0 ? 'decrease': ''}}">
                    (
                    <ng-container *ngIf="changelog.doc['sivt']['change']>0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#248D48"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="translate(-37 -4)" />
                      </svg>
                    </ng-container>
                    <ng-container *ngIf="changelog.doc['sivt']['change']<0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#D12727"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="matrix(1 0 0 -1 -37 10)" />
                      </svg>
                    </ng-container>
                    {{changelog.doc['sivt']['change'] | abperc:'1.2-2'}})
                  </span>
                </div>
              </ng-container>

              <!-- Traffic -- DAU -->
              <ng-container *ngIf="changelog.doc.dailyActiveUsers && isTraffic">
                <div class="timeline-change-item">
                  <span class="detail-section traffic">Traffic</span> Est. Daily Reach up to
                  {{changelog.doc['dailyActiveUsers']['latestVal'] | roundsig: '0a'}}
                  <span class="change-value {{changelog.doc['dailyActiveUsers']['change'] < 0 ? 'decrease': ''}}">
                    (
                    <ng-container *ngIf="changelog.doc['dailyActiveUsers']['change']>0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#248D48"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="translate(-37 -4)" />
                      </svg>
                    </ng-container>
                    <ng-container *ngIf="changelog.doc['dailyActiveUsers']['change']<0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#D12727"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="matrix(1 0 0 -1 -37 10)" />
                      </svg>
                    </ng-container>
                    {{changelog.doc['dailyActiveUsers']['change'] | abperc:'1.2-2'}})
                  </span>
                </div>
              </ng-container>

              <!-- Traffic -- MAU -->
              <ng-container *ngIf="changelog.doc.monthlyActiveUsers && isTraffic">
                <div class="timeline-change-item">
                  <span class="detail-section traffic">Traffic</span> Est. Monthly Reach up to
                  {{changelog.doc['monthlyActiveUsers']['latestVal'] | roundsig: '0a'}}
                  <span class="change-value {{changelog.doc['monthlyActiveUsers']['change'] < 0 ? 'decrease': ''}}">
                    (
                    <ng-container *ngIf="changelog.doc['monthlyActiveUsers']['change']>0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#248D48"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="translate(-37 -4)" />
                      </svg>
                    </ng-container>
                    <ng-container *ngIf="changelog.doc['monthlyActiveUsers']['change']<0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#D12727"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="matrix(1 0 0 -1 -37 10)" />
                      </svg>
                    </ng-container>
                    {{changelog.doc['monthlyActiveUsers']['change'] | abperc:'1.2-2'}})
                  </span>
                </div>
              </ng-container>

              <!-- Traffic -- Ad Spend -->
              <ng-container *ngIf="changelog.doc.adSpent && isTraffic">
                <div class="timeline-change-item">
                  <span class="detail-section traffic">Traffic</span> Ad Spend {{changelog.doc['adSpent']['latestVal'] |
                  roundsig: '0.0a'}}
                  <span class="change-value {{changelog.doc['adSpent']['change'] < 0 ? 'decrease': ''}}">
                    (
                    <ng-container *ngIf="changelog.doc['adSpent']['change']>0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#248D48"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="translate(-37 -4)" />
                      </svg>
                    </ng-container>
                    <ng-container *ngIf="changelog.doc['adSpent']['change']<0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#D12727"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="matrix(1 0 0 -1 -37 10)" />
                      </svg>
                    </ng-container>
                    {{changelog.doc['adSpent']['change'] | abperc:'1.2-2'}})
                  </span>
                </div>
              </ng-container>

              <!-- Traffic -- Spoofing Risk -->
              <ng-container *ngIf="changelog.doc.spoofingRisk && isTraffic">
                <div class="timeline-change-item">
                  <span class="detail-section traffic">Traffic</span>
                  <span>
                    Spoofing Risk level changed to&nbsp;
                  </span>
                  <risk-heat-meter [risk]='changelog.doc?.spoofingRisk?.latestVal'></risk-heat-meter>
                </div>
              </ng-container>

              <!-- Developer -- Privacy Policy -->
              <ng-container *ngIf="changelog.doc.hasPrivacyLink && isAdvisory">
                <div class="timeline-change-item">
                  <span class="detail-section developer">Developer</span> Privacy Policy
                  {{changelog.doc['hasPrivacyLink']['latestVal'] === 'true' ? 'detected' : 'not detected'}}
                </div>
              </ng-container>

              <!-- Developer -- Terms and Conditions -->
              <ng-container *ngIf="changelog.doc.hasTermsAndConditions && isDeveloper">
                <div class="timeline-change-item">
                  <span class="detail-section developer">Developer</span> Terms and Conditions updated
                </div>
              </ng-container>

              <!-- Developer Location -- -->
              <ng-container *ngIf="changelog.doc.location && isDeveloper">
                <div class="timeline-change-item">
                  <span class="detail-section developer">
                    {{locationLabel ? locationLabel : 'Developer Location'}}
                  </span>
                  {{locationDescription ? locationDescription : 'Developer location updated.'}}
                  <a data-html="true"
                    title="{{changelog.doc?.location?.oldVal}}<br/>to<br/>{{changelog.doc?.location?.latestVal}}"
                    (click)="copyToCbLocation(changelog.doc?.location, $event)">
                    [Click Here]
                    <a class="copyClipboard" title="copied to clipboard..." data-toggle="tooltip"></a>
                  </a>
                  &nbsp;for location updates.
                </div>
              </ng-container>

              <!-- Inventory -- Impression Volume -->
              <ng-container *ngIf="changelog.doc.impressions && isInventory">
                <div class="timeline-change-item">
                  <span class="detail-section inventory">Inventory</span> Impression Volume
                  <span class="change-value {{changelog.doc['impressions']['change'] < 0 ? 'decrease': ''}}">
                    (
                    <ng-container *ngIf="changelog.doc['impressions']['change']>0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#248D48"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="translate(-37 -4)" />
                      </svg>
                    </ng-container>
                    <ng-container *ngIf="changelog.doc['impressions']['change']<0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 5 6">
                        <polygon fill="#D12727"
                          points="42 6.27 39.5 4 37 6.27 37.76 7.17 39 6.05 39 10 40 10 40 6.05 41.24 7.17"
                          transform="matrix(1 0 0 -1 -37 10)" />
                      </svg>
                    </ng-container>
                    {{changelog.doc['impressions']['change'] | abperc:'1.2-2'}})
                  </span>
                </div>
              </ng-container>

              <!-- Authorized Seller -->
              <ng-container *ngIf="changelog.doc?.sellers?.latestVal?.length > 0 && isSeller">
                <div class="timeline-change-item" *ngFor="let seller of changelog.doc?.sellers?.latestVal">
                  <span class="detail-section seller">Authorized Seller</span>
                  <div class="d-flex flex-wrap">
                    <span class="mr-1" *ngIf="seller?.state === 'added'">New </span>
                    <span class="mr-1 sellerName">{{seller?.sellerName}} </span>
                    <span class="mr-1" *ngIf="seller?.state !== 'updated'">{{seller?.state}} </span>
                    <span class="mr-1" *ngIf="seller?.state === 'updated'">moved </span>
                    <span class="mr-1" *ngIf="seller?.state === 'added'">to </span>
                    <span class="mr-1" *ngIf="seller?.state === 'updated' || seller?.state ==='removed'">from </span>
                    <span *ngIf="seller?.state !== 'updated'">{{seller?.type}}</span>
                    <span *ngIf="seller?.state === 'updated'">{{seller?.oldType}} to {{seller?.type}}</span>
                  </div>
                </div>
              </ng-container>

            </li>
          </ng-container>

        </ul>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!changeLogMonths">
      <h3 class="month">No change log data found.</h3>
    </ng-container>
  </div>
</div>